import { render, staticRenderFns } from "./pong.component.vue?vue&type=template&id=c2506b84&scoped=true&"
import script from "./pong.component.vue?vue&type=script&lang=js&"
export * from "./pong.component.vue?vue&type=script&lang=js&"
import style0 from "./pong.component.vue?vue&type=style&index=0&id=c2506b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2506b84",
  null
  
)

export default component.exports